import { FC, ReactNode, Suspense, lazy } from 'react';
import { XmEmailGroups } from 'src/component/emailGroups/XmEmailGroups';
import { XmSpinner } from 'src/component/spinner/XmSpinner';
import { REPORTER_SECTIONS, ReporterSectionPath } from 'src/content/tools/reporter/reporterMenu';
import { RoutePath } from 'src/data/Routes';
import { RouteToolSections } from 'src/routing/RouteToolSections';

const Reporter = lazy(() => import('src/content/tools/reporter/components/Reporter'));

const SECTION_CONTENT: Record<ReporterSectionPath, ReactNode> = {
  '/reports': <Suspense fallback={<XmSpinner />}><Reporter /></Suspense>,
  '/email': <XmEmailGroups />,
};

export const RouteReporter: FC = () => (
  <RouteToolSections
    rootPath={RoutePath.REPORTER}
    title='Reporter'
    sections={REPORTER_SECTIONS}
    renderSection={section => SECTION_CONTENT[section.path]}
  />
);
